export default __webpack_public_path__ + "static/step-6e7beedca8df6329c305b8676084b76d6feaa02389b7e34b97559436930f82da.png";